import React from "react";
import { useTranslation } from "react-i18next";
import * as styles from "./style";
import { Colors } from "../../../../utils/style/colors";
import {
  responseStatusColor,
  responseStatusText,
  situationText,
} from "../../situationText";

export const SituationStatus = ({ response, muted }) => {
  const { t } = useTranslation();
  if (!response) return null;
  const status = responseStatusText(t, response);
  if (!status) return null;
  const text =
    response.requestCount > 1
      ? `${status} · ${situationText(t, "requestCount", {
          count: response.requestCount,
        })}`
      : status;
  return (
    <styles.SituationStatus $muted={muted} title={text}>
      <styles.StatusDot
        $color={muted ? Colors.gray40 : responseStatusColor(response)}
      />
      {text}
    </styles.SituationStatus>
  );
};

export default SituationStatus;
